import "whatwg-fetch";
class Voucher {
  constructor() {
    this.cache = {};
    this.button = $("#voucher button");
    this.loader = $("#voucher .loader");
    this.check = $("#voucher .circle_check");
  }

  redeem(value, checked_package, type) {
    if (type == "voucher") {
      this.button.hide();
      this.loader.show();
      this.check.hide();
      if (type == "voucher" && $("#summary .cloned:not(.hidden)").length) {
        $("#summary .cloned").next().removeClass("hidden");
        $("#summary .cloned").remove();
      }
    }
    if (value != "") {
      let package_value = checked_package || "0";
      let package_name = window.Translator.trans(
        "packages.name." + package_value,
        {},
        "js"
      );
      let url = "/admin/voucher/" + value + "/" + package_name;
      if (
        typeof this.cache[url] !== "undefined" &&
        typeof this.cache[url]["code"] !== "undefined"
      ) {
        this.add(this.cache[url], package_value);
      } else {
        window
          .fetch(url)
          .then((res) => res.json())
          .then(
            (result) => {
              this.cache[url] = result;
              if (typeof result.code !== "undefined") {
                this.add(result, package_value);
                // }
              } else {
                this.reset(true);
              }
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              this.reset(true);
            }
          );
      }
    } else {
      this.reset(false);
    }
  }

  add(voucherData, package_value) {
    if (voucherData.type == "MIRROR") {
      let event = new CustomEvent("updateSummaryMirror");
      window.dispatchEvent(event);
    } else {
      $("#summary .voucher").removeClass("inactive calculate");
      $("#summary .voucher").addClass("hidden");

      if (typeof voucherData != "undefined") {
        let title = voucherData.title || null;
        let description = voucherData.description || null;

        if (title == null) {
          title = window.Translator.trans(
            "summary.voucher." + voucherData.discount_unit + ".title",
            { brand: voucherData.brand || "", logo: voucherData.logo || "" },
            "js"
          );
        }
        if (description == null) {
          description = window.Translator.transChoice(
            "summary.voucher." + voucherData.discount_unit + ".description",
            package_value > 0 ? voucherData.value : 0,
            { amount: voucherData.value },
            "js"
          );
        }

        $("#summary .voucher.platform-" + package_value + " td")
          .attr("colspan", 1)
          .attr("style", "");
        $("#summary .voucher.platform-" + package_value).attr(
          "data-type",
          voucherData.discount_unit
        );
        $("#summary .voucher.platform-" + package_value).attr(
          "data-amount",
          voucherData.value
        );
        $("#summary .voucher.platform-" + package_value + " td.title").html(
          title
        );
        if (voucherData.discount_unit == "MONTH") {
          $("#summary .voucher.platform-" + package_value).removeClass(
            "calculate"
          );
          $(
            "#summary .voucher.platform-" + package_value + " td.amount"
          ).hide();
          $(
            "#summary .voucher.platform-" + package_value + " td.discount"
          ).hide();
          $(
            "#summary .voucher.platform-" + package_value + " td.description"
          ).attr("colspan", 3);
          $(
            "#summary .voucher.platform-" + package_value + " td.description"
          ).html(
            '<em class="strong">' + this.cleanString(description) + "</em>"
          );
        } else if (voucherData.discount_unit == "FREE_PERIOD") {
          $("#summary .voucher.platform-" + package_value).removeClass(
            "calculate"
          );
          $(
            "#summary .voucher.platform-" + package_value + " td.amount"
          ).hide();
          $(
            "#summary .voucher.platform-" + package_value + " td.discount"
          ).hide();
          $("#summary .voucher.platform-" + package_value + " td.description")
            .attr("colspan", 3)
            .addClass("pe-0");
          $(
            "#summary .voucher.platform-" + package_value + " td.description"
          ).html(
            '<em class="strong">' + this.cleanString(description) + "</em>"
          );
          let $originalLine = $(
            "#summary .platform.platform-" +
              package_value +
              ".calculate:not(.hidden)"
          );
          $originalLine.find(".abo-amount").removeAttr("name");
          let $trLine = $originalLine.clone();
          if ($trLine.length > 0) {
            $trLine.detach();
            $trLine.insertBefore(
              $(
                "#summary .platform.platform-" +
                  package_value +
                  ".calculate:not(.hidden)"
              ).addClass("hidden")
            );
            $trLine.addClass("cloned");
            $trLine.attr("data-amount", 0);
            $trLine.attr("data-abo", voucherData.value);
            $trLine
              .find(".abo")
              .html(
                window.Translator.trans(
                  "summary.voucher.monthly",
                  { period: voucherData.value, amount: amountToHuman(0, true) },
                  "js"
                )
              );
            $trLine.find(".abo").append(
              $("<input>").attr({
                type: "hidden",
                id: "abo-discount",
                value: voucherData.value,
                name: $(".platform_abo").attr("name"),
              })
            );
            $trLine.find(".total-abo").text(amountToHuman(0.0));
            if ($("#rental-mirror").length) {
              $("#summary .mirror.platform-" + package_value)
                .removeClass("calculate")
                .addClass("hidden");
            }
          }

          $(
            "#summary .platform.platform-" + package_value + " td.description"
          ).html(
            '<em class="strong">' + this.cleanString(description) + "</em>"
          );
        } else if (voucherData.discount_unit == "PERCENTAGE") {
          $("#summary .voucher.platform-" + package_value).addClass(
            "calculate"
          );
          $(
            "#summary .voucher.platform-" + package_value + " td.description"
          ).hide();
          $(
            "#summary .voucher.platform-" + package_value + " td.discount"
          ).html(voucherData.value + " %");
        } else if (voucherData.discount_unit == "VALUE") {
          $("#summary .voucher.platform-" + package_value).addClass(
            "calculate"
          );
          $(
            "#summary .voucher.platform-" + package_value + " td.description"
          ).hide();
          $(
            "#summary .voucher.platform-" + package_value + " td.discount"
          ).hide();
          $("#summary .voucher.platform-" + package_value + " td.amount").attr(
            "colspan",
            3
          );
          $("#summary .voucher.platform-" + package_value + " td.amount").html(
            "-".concat(amountToHuman(voucherData.value * 1.0))
          );
        }

        this.button.hide();
        this.loader.hide();
        this.check.show();
      }
      $("#summary .voucher.platform-" + package_value).removeClass(
        "inactive hidden"
      );
    }

    $("#summary").trigger("recalculate");
  }

  reset(showAlert) {
    this.button.show();
    this.check.hide();
    $("#voucher input[type=text]").val("");

    $("#summary .voucher").addClass("inactive hidden");
    $("#summary .voucher").removeAttr("data-type");
    $("#summary .voucher").removeAttr("data-amount");
    $("#summary .voucher").removeClass("calculate");
    $("#summary .voucher td").html("");
    $("#summary").trigger("recalculate");
    this.loader.hide();
    if (showAlert) {
      alert(window.Translator.trans("summary.voucher.invalid", {}, "js"));
    }
  }

  cleanString(res) {
    res = res.replace(/{.} /g, "");
    res = res.replace(/\[.*\] /g, "");
    return res;
  }
}
export default Voucher;
